var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToBasketMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 9.12h-2.23v-.26c-.02-1.67-1.38-3-3.05-2.99h-.06c-1.67.02-3 1.38-2.98 3.05v.2H8.73c-.67.02-1.2.55-1.22 1.22V20.9c.02.67.55 1.2 1.22 1.22h10.56c.67-.02 1.2-.55 1.22-1.22V10.34c-.01-.67-.55-1.21-1.22-1.22Zm-7.11-.2a1.83 1.83 0 0 1 3.66 0v.2h-3.66v-.2Zm7.11 11.98H8.72V10.34h2.23v1.83c0 .34.27.61.61.61s.61-.27.61-.61v-1.83h3.66v1.83c0 .34.27.61.61.61s.61-.27.61-.61v-1.83h2.23V20.9Z",
    fill: "#212529"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.68 19.01v-2.68H11v-.64h2.68v-2.68h.64v2.68H17v.64h-2.68v2.68h-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.82 19.51h-1.64v-2.68H10.5v-1.64h2.68v-2.68h1.64v2.68h2.68v1.64h-2.68v2.68z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h28v28H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToBasketMobile);
export default __webpack_public_path__ + "static/media/AddToBasketMobile.1a445468858e15b2fef10bcac498d3bd.svg";
export { ForwardRef as ReactComponent };